module.exports = __webpack_public_path__ + "img/sell-active.10bfce03.png";